import qs from 'qs'
import {removeAuthorization} from "@/utils/request.js"; //移除登录验证数据

const request = {
    /**
     * 发送请求之前做些什么
     * @param config axios config
     * @param options 应用配置 包含: {router, store, message}
     * @returns {*}
     */
    onFulfilled(config, options) {
        const {message} = options
        const {url} = config
        // console.log('config',config)

        let token = localStorage.getItem('token')
        if (config.method === 'post') {
            config.data.token = token
            config.data = qs.stringify(config.data);
            config.headers['platform'] = 'H5';
        }
        if (config.method === 'get') {
            config.params.token = token
        }
        return config
    },

    /**
     * 请求出错时做点什么
     * @param error 错误对象
     * @param options 应用配置 包含: {router, store, message}
     * @returns {Promise<never>}
     */
    onRejected(error, options) {
        console.log('请求出错')
        console.log('error',error)
        console.log('options',options)
        const {message} = options
        message.error(error.message)
        return Promise.reject(error)
    }
}

const response = {
    /**
     * 响应数据之前做点什么
     * @param response 响应对象
     * @param options 应用配置 包含: {router, store, message}
     * @returns {*}
     */
    onFulfilled(response, options) {
        const {message} = options
        const result = response.data
        // console.log('响应数据')
        // console.log('message',message)
        // console.log('result',result)
        
        // code等于1或2时都认为请求成功，其他code值按业务逻辑处理
        if (result.code == 1 || result.code == 2) {
            return Promise.resolve(result)
        } else {
            // 其他情况都显示错误信息
            const errorMsg = result.msg || '请求失败'
            message.error(errorMsg)
            return Promise.reject(new Error(errorMsg))
        }
    },

    /**
     * 响应出错时执行
     * @param error 错误对象
     * @param options 应用配置 包含: {router, store, message}
     * @returns {Promise<never>}
     */
    onRejected(error, options) {
        const {router, message} = options
        const {response} = error
        console.log(error)
        
        // 如果有响应数据，优先使用响应中的错误信息
        if (response && response.data) {
            const {code, msg} = response.data
            if (code !== 1) {
                const errorMsg = msg || '请求失败'
                message.error(errorMsg)
            }
        }
        
        let status = response?.status || 500;
        let responseMsg = response?.data?.msg
        let msg
        switch (status) {
            case 401:
                msg = responseMsg ? responseMsg : '登录过期'
                break;
            case 403:
                msg = responseMsg ? responseMsg : '请求被拒绝'
                break;
            case 500:
            default:
                msg = responseMsg ? responseMsg : '服务器开小差了'
                break
        }
        
        // 显示错误信息
        message.error(msg)
        
        let path = router.currentRoute.value.path;
        path = path.split('/')
        // console.log(path[1])
        // console.log('开来看啊看啊',response.status)
        if (status === 401 && path[1] !='logins') {
            sessionStorage.removeItem('token')
            removeAuthorization()

            setTimeout(() => {
                router.push('/login')
            }, 100)
            return false
        }

        return Promise.reject(error)
    }
}

export default {
    request: [request], // 请求拦截
    response: [response] // 响应拦截
}
